/*
 * IMPORTS
 */
import React from 'react'
import PropTypes from 'prop-types'
import NaturalCompare from 'natural-compare'
import _ from 'underscore'
import { useQuery } from '@apollo/client'
import { MemoizedSelect } from 'components/MemoizedInput'
import MccReadQuery from './__query__/index.mcc.read.query'


/*
 * OBJECTS
 */
const Index = ({ mccValue, isMccGlobal, disabled, inValidMcc, isRequired, onChange }) => {
  // Hook assignment.
  const [mcc, setMcc] = React.useState('')
  const _isGlobalAppliedRef = React.useRef(false)
  const _QueryMccRead = useQuery(MccReadQuery, { 'variables': { 'take': 1000, 'skip': 0 }, 'fetchPolicy': Object.React.App.fetchPolicy })

  // Event handler.
  React.useEffect(() => {
    !_.isEmpty(mccValue) && _.isEmpty(mcc) && setMcc(mccValue)
  }, [mcc, mccValue])

  React.useEffect(() => {
    if (isMccGlobal && !_isGlobalAppliedRef.current) {
      _QueryMccRead?.data?.MccRead?.forEach?.(j => {
        if (0 === parseInt(j.mcc, 10)) {
          setMcc(`${j.countryName} (${j.mcc})`)
          onChange?.({ 'mcc': `${j.countryName} (${j.mcc})` })
          _isGlobalAppliedRef.current = true
        }
      })
    }
  }, [_QueryMccRead?.data?.MccRead, isMccGlobal, onChange])

  // Const assignment.
  const _mccOptions = React.useMemo(() => 
    _.compact(
      _QueryMccRead?.data?.MccRead?.map?.(j => 
        'READ_SUCCESSFUL' === j.status ? `${j.countryName} (${j.mcc})` : void 0
      )
    )?.sort((a, b) => NaturalCompare(a, b)), 
  [_QueryMccRead?.data?.MccRead])

  const _HandleMccChange = React.useCallback(__event => {
    setMcc(__event.target.value)
    onChange?.({ 'mcc': __event.target.value })
  }, [onChange])

  // Return the JSX.
  return (
    <MemoizedSelect
      // label='Country Mcc'
      disabled={_QueryMccRead?.loading || disabled}
      name='mcc'
      value={mcc}
      bg='purple.50'
      color='purple'
      height='100%'
      placeholder='Select Country'
      options={_mccOptions}
      isInvalid={inValidMcc}
      isRequired={isRequired}
      onChange={_HandleMccChange}
    />
  )
}


/*
 * PROPTYPES
 */
Index.propTypes = {
  'mccValue': PropTypes.string,
  'disabled': PropTypes.bool,
  'inValidMcc': PropTypes.bool,
  'onChange': PropTypes.func,
  'isRequired': PropTypes.bool,
  'isMccGlobal': PropTypes.bool
}


/*
 * EXPORT
 */
export default React.memo(Index)